import { TagManager } from '@navent-jobs/config'

export const DataLayers = {
  ReferenciaSalarialOnClick: subArea => {
    /**
     * El objetivo es trackear cuándo el usuario desea saber más sobre la referencia salarial del área que está buscando.
     *
     * Debe dispararse cuando el usuario hace click en “Ver”.
     */

    TagManager.Push({
      event: 'trackEvent',
      eventCategory: 'Aviso',
      eventAction: 'Ver mas-Referencia salarial',
      eventLabel: `${subArea}`,
    })
  },
}
